
"use client";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import type { Dispatch, SetStateAction } from "react";

type FilterControlsProps = {
  filterKeyword: string;
  setFilterKeyword: Dispatch<SetStateAction<string>>;
  disabled?: boolean;
};

export function FilterControls({ filterKeyword, setFilterKeyword, disabled = false }: FilterControlsProps) {
  return (
    <div className="space-y-2">
      <Label htmlFor="filterKeyword">Filter by keyword or attribute</Label>
      <div className="flex items-center space-x-2">
        <Input
          id="filterKeyword"
          type="text"
          placeholder="Enter keyword..."
          value={filterKeyword}
          onChange={(e) => setFilterKeyword(e.target.value)}
          disabled={disabled}
          aria-label="Filter messages by keyword"
          className="flex-grow"
        />
        {filterKeyword && (
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setFilterKeyword("")}
            disabled={disabled}
            aria-label="Clear filter"
            className="h-9 w-9 p-0"
          >
            <X className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
}
